import { createRouter, createWebHashHistory } from 'vue-router'
import Header from '../views/commons/Header.vue'
import Footer from '../views/commons/Footer.vue'
import Bot from '../views/commons/Bot.vue'
import store from '../store/index.js'

const routes = [

  {
    path: '/:pathMatch(.*)*',
    redirect: '/error'
  },

  {
    path: '/P1',
    name: 'P1',
    components: {
      header: Header,
      footer: Footer,
      default: () => import('../views/P1.vue') },
    meta: {
      title: '中信卡公用事業代繳|登入頁'
    }
  },

  {
    path: '/P2',
    name: 'P2',
    components: {
      header: Header,
      footer: Footer,
      bot: Bot,
      default: () => import('../views/P2.vue') },
    meta: {
      title: '中信卡公用事業代繳|身分驗證'
    }
  },

  {
    path: '/P3/:applyId',
    name: 'P3',
    components: {
      header: Header,
      footer: Footer,
      default: () => import('../views/P3.vue') },
    meta: {
      title: '中信卡公用事業代繳'
    }
  },

  {
    path: '/P4',
    name: 'P4',
    components: {
      header: Header,
      footer: Footer,
      bot: Bot,
      default: () => import('../views/P4.vue') },
    meta: {
      title: '中信卡公用事業代繳網|eTag自動儲值'
    }
  },

  {
    path: '/P5',
    name: 'P5',
    components: {
      header: Header,
      footer: Footer,
      bot: Bot,
      default: () => import('../views/P5.vue') },
    meta: {
      title: '中信卡公用事業代繳網|查詢頁'
    }
  },

  {
    name: 'Error',
    path: '/error',
    components: {
      header: Header,
      footer: Footer,
      default: () => import('../views/P0.vue')
    },
    meta: {
      title: '中信卡公用事業代繳'
    },
    props: {
      default: route => ({ ...route.query, ...route.params })
    }
  }

]

const router = createRouter({
  history: createWebHashHistory('/etag/'),
  routes
})

router.beforeEach((to, from) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.name === 'P1') {
    store.state.showGoHome = false
  } else {
    store.state.showGoHome = true
  }
})

export default router
